
import { defineComponent } from "vue";

export default defineComponent({
  name: "TermsConditions",
  setup() {
    return {};
  },
});
